import { useEffect, useState } from "react";
import { Sparkles, LogIn, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function JoinCreate() {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/gallery/showcase`)
      .then((r) => r.json())
      .then((d) => {
        const items = d.items || [];
        if (items.length) {
          const idx = Number(sessionStorage.getItem("join_idx") || 0) % items.length;
          setItem(items[idx]);
          sessionStorage.setItem("join_idx", String((idx + 1) % items.length));
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const go = (mode) => { window.location.href = `/?auth=${mode}`; };

  const Logo = () => (
    <div data-testid="join-logo" className="select-none leading-none">
      <span className="block font-serif font-black tracking-tight text-[#F9E27D] text-6xl sm:text-7xl lg:text-8xl drop-shadow-[0_0_24px_rgba(249,226,125,0.35)]">MiST</span>
      <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.4em] text-white/50">misteck</span>
    </div>
  );

  const Buttons = () => (
    <div className="w-full max-w-xs space-y-3" data-testid="join-actions">
      <button onClick={() => go("signup")} data-testid="join-create-btn"
        className="w-full flex items-center justify-center gap-2 bg-[#F9E27D] text-black font-black font-mono text-sm uppercase tracking-widest py-4 rounded-full border-2 border-black shadow-[4px_4px_0px_#000] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none transition-transform">
        <Sparkles size={18} strokeWidth={2.5} /> Join + Create
      </button>
      <button onClick={() => go("signin")} data-testid="join-signin-btn"
        className="w-full flex items-center justify-center gap-2 bg-transparent text-white font-black font-mono text-sm uppercase tracking-widest py-4 rounded-full border-2 border-white/40 active:translate-y-[2px] transition-transform">
        <LogIn size={18} strokeWidth={2.5} /> Sign In
      </button>
      <p className="text-center font-mono text-[10px] text-white/40 pt-1">Create. Share. Get paid. · misteck.com</p>
    </div>
  );

  const Viewer = () => (
    <div data-testid="join-showcase" className="relative w-full h-full min-h-[280px] rounded-2xl border-2 border-white/10 overflow-hidden bg-[#0d0d0f] grid place-items-center">
      {loading ? (
        <Loader2 className="animate-spin text-[#F9E27D]" size={28} />
      ) : item ? (
        <img src={`${API}${item.url}`} alt={item.key || "showcase"} data-testid="join-showcase-img"
          className="w-full h-full object-cover" />
      ) : (
        <div className="text-center px-6">
          <Sparkles className="mx-auto mb-3 text-[#F9E27D]" size={30} />
          <p className="font-mono text-[11px] uppercase tracking-widest text-white/40">Fresh creations dropping soon</p>
        </div>
      )}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
    </div>
  );

  return (
    <div data-testid="join-create-page" className="min-h-screen w-full bg-[#0a0a0b] text-white overflow-y-auto">
      {/* Desktop: left 1/3 (logo + buttons) · right 2/3 (viewer) */}
      <div className="hidden md:grid md:grid-cols-3 md:h-screen">
        <div className="col-span-1 flex flex-col justify-center gap-10 px-10 lg:px-14">
          <Logo />
          <Buttons />
        </div>
        <div className="col-span-2 p-6 lg:p-8">
          <Viewer />
        </div>
      </div>

      {/* Mobile: logo → viewer → buttons */}
      <div className="md:hidden flex flex-col items-center gap-6 px-6 py-10 min-h-screen">
        <Logo />
        <div className="w-full flex-1 min-h-[46vh]"><Viewer /></div>
        <Buttons />
      </div>
    </div>
  );
}
